module.exports = __webpack_public_path__ + "img/animals@2x.532c065.webp";